
export default function Panel_Groups_Settings_P()
{
  return (
    <div>
      <h1>تنظیمات گروه</h1>
    </div>
  );
}
